import styled from 'styled-components';

import Link from '../../assets/link.svg';

const LinkImg = styled.div`
  width: 24px;
  height: 24px;

  background-image: url(${Link});
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
  margin-right: 6px;
`;

export default LinkImg;
